"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferReminderSchema = exports.OfferLetterSchema = exports.RecipientDeliverySchema = exports.JobOfferreminderTemplateSchema = exports.OfferLetterTemplateSchema = exports.BaseOfferTemplateSchema = exports.OfferReminderMessageSchema = exports.OfferLetterMessageSchema = exports.IntroductionSchema = exports.NameSchema = exports.SubjectSchema = exports.OFFER_FORM_CONSTRAINTS = exports.OfferTypeEnum = exports.RecruitmentPolicySchema = exports.ExemptionSchema = void 0;
const zod_1 = require("zod");
const shared_1 = require("../shared");
exports.ExemptionSchema = zod_1.z.enum([
    'SKIP_RESUME_SCREENING',
    'SKIP_FIRST_INTERVIEW',
    'SKIP_FIRST_AND_SECOND_INTERVIEWS',
]);
exports.RecruitmentPolicySchema = zod_1.z.enum([
    'CASUAL_INTERVIEW_ACCEPTED',
    'OPEN_APPLICATION_ACCEPTED',
    'PREVIOUS_SALARY_GUARANTEED',
]);
exports.OfferTypeEnum = zod_1.z.enum(['OFFER', 'REMINDER']);
exports.OFFER_FORM_CONSTRAINTS = {
    LETTER: { INTRO: { MAX: 150, MIN: 1 }, MESSAGE: { MAX: 1500, MIN: 1 } },
    NAME: { MAX: 40, MIN: 1 },
    REMINDER: { MESSAGE: { MAX: 500, MIN: 1 } },
    SUBJECT: { MAX: 100, MIN: 1 },
};
exports.SubjectSchema = zod_1.z
    .string()
    .min(exports.OFFER_FORM_CONSTRAINTS.SUBJECT.MIN, 'Subject is required')
    .max(exports.OFFER_FORM_CONSTRAINTS.SUBJECT.MAX, `Subject must be ${exports.OFFER_FORM_CONSTRAINTS.SUBJECT.MAX} characters or less`);
exports.NameSchema = zod_1.z
    .string()
    .min(exports.OFFER_FORM_CONSTRAINTS.NAME.MIN, 'Template name is required')
    .max(exports.OFFER_FORM_CONSTRAINTS.NAME.MAX, `Template name must be ${exports.OFFER_FORM_CONSTRAINTS.NAME.MAX} characters or less`);
exports.IntroductionSchema = zod_1.z
    .string()
    .min(exports.OFFER_FORM_CONSTRAINTS.LETTER.INTRO.MIN, 'Introduction is required')
    .max(exports.OFFER_FORM_CONSTRAINTS.LETTER.INTRO.MAX, `Introduction must be ${exports.OFFER_FORM_CONSTRAINTS.LETTER.INTRO.MAX} characters or less`);
exports.OfferLetterMessageSchema = zod_1.z
    .string()
    .min(exports.OFFER_FORM_CONSTRAINTS.LETTER.MESSAGE.MIN, 'Message is required')
    .max(exports.OFFER_FORM_CONSTRAINTS.LETTER.MESSAGE.MAX, `Message must be ${exports.OFFER_FORM_CONSTRAINTS.LETTER.MESSAGE.MAX} characters or less`);
exports.OfferReminderMessageSchema = zod_1.z
    .string()
    .min(exports.OFFER_FORM_CONSTRAINTS.REMINDER.MESSAGE.MIN, 'Message is required')
    .max(exports.OFFER_FORM_CONSTRAINTS.REMINDER.MESSAGE.MAX, `Message must be ${exports.OFFER_FORM_CONSTRAINTS.REMINDER.MESSAGE.MAX} characters or less`);
exports.BaseOfferTemplateSchema = zod_1.z.object({
    id: shared_1.UUIDSchema,
    name: exports.NameSchema,
    subject: exports.SubjectSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
exports.OfferLetterTemplateSchema = exports.BaseOfferTemplateSchema.extend({
    recruiterId: shared_1.UUIDSchema,
    exemptions: exports.ExemptionSchema.array().optional(),
    introduction: exports.IntroductionSchema,
    message: exports.OfferLetterMessageSchema,
    policies: exports.RecruitmentPolicySchema.array().optional(),
});
exports.JobOfferreminderTemplateSchema = exports.BaseOfferTemplateSchema.extend({
    message: exports.OfferReminderMessageSchema,
});
exports.RecipientDeliverySchema = zod_1.z.object({
    candidateId: shared_1.UUIDSchema,
    isScheduled: zod_1.z.boolean().default(false),
    scheduledAt: shared_1.ISODateTimeSchema.nullish(),
});
exports.OfferLetterSchema = exports.OfferLetterTemplateSchema
    .omit({ name: true })
    .extend({ type: zod_1.z.literal(exports.OfferTypeEnum.enum.OFFER) })
    .extend(exports.RecipientDeliverySchema.shape);
exports.OfferReminderSchema = exports.JobOfferreminderTemplateSchema
    .omit({ name: true })
    .extend({ type: zod_1.z.literal(exports.OfferTypeEnum.enum.REMINDER) })
    .extend(exports.RecipientDeliverySchema.shape);
